<template>
  <b-modal
    ref="modal"
    centered
    hide-footer
    size="md"
    static
    class="login-register"
  >
    <b-img
      slot="modal-header-close"
      :src="require('@/assets/icons/x-b.svg')"
      width="45"
      height="30"
    ></b-img>

    <div class="d-flex justify-content-center align-items-center">
      <b-row no-gutters class="w-100">
        <b-col class="text-center">
          <b-img
            :src="require('@/assets/images/logo-title-b.svg')"
            class="login-register__logo"
            fluid
          />

          <b-navbar-nav class="login-register__nav justify-content-center">
            <b-nav-item
              v-for="section in sections"
              :class="{
                active: active === section.value
              }"
              :key="section.value"
              @click="setSection(section.value)"
              >{{ section.label }}<span class="dots"></span
            ></b-nav-item>
          </b-navbar-nav>

          <login-form
            v-if="active == sections[0].value"
            :callback="callback"
            :autologin="false"
          />
          <register-form v-else :autologin="false" />
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>
<script>
/**
 * ==================================================================================
 * Login and Register modal
 * ==================================================================================
 **/

import LoginForm from '@/components/forms/LoginForm'
import RegisterForm from '@/components/forms/RegisterForm'

export default {
  components: {
    LoginForm,
    RegisterForm
  },
  data: function() {
    return {
      active: 1,
      callback: null,
      sections: [
        { value: 1, label: 'Sign in' },
        { value: 2, label: 'Register' }
      ]
    }
  },
  methods: {
    setSection(value) {
      this.active = value
    },

    show(fn) {
      this.callback = fn
      this.$refs.modal.show()
    },

    close() {
      this.$refs.modal.hide()
    }
  }
}
</script>
<style lang="scss" scoped>
.login-register /deep/ {
  .modal-header {
    padding-bottom: 0;

    .close {
      position: absolute;
      left: 0;
      z-index: 9999;
    }
  }

  .modal-body {
    padding-top: 10px;

    .login-register__logo {
      width: 150px;
      margin-bottom: 45px;
    }

    .login-register__nav {
      margin: 0 25px;
      flex-direction: row;

      .nav-item {
        padding: 0 12.5px;

        > a {
          font-size: 1.1rem;
          font-weight: 400;
          color: #b5b5b5;
        }

        .dots {
          display: block;
          width: 6px;
          height: 6px;
          background: transparent;
          border-radius: 50%;
          margin: 7px auto 0 auto;
        }
      }

      .nav-item.active {
        > a {
          font-weight: 700;
          color: var(--brand-green);
        }

        .dots {
          background: transparent;
          background: var(--brand-green);
        }
      }
    }

    .login-form,
    .register-form {
      margin-top: 20px;

      #google-signin-button .abcRioButtonContents {
        font-size: 0.95rem !important;
      }
    }

    .register-form {
      .submit-btn {
        margin-top: 25px;
      }
    }
  }
}
</style>
